import type { ReactNode } from 'react';
import React from 'react';
import { Button } from 'Components/frameworks/button/Button';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Title } from 'Components/frameworks/title/Title';
import { t } from 'Src/i18n';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
type Props = {
  bannerPadding?: string;
  bannerTitle: string;
  ctaAction: () => void;
  ctaText: string;
  dataTestId?: string;
  iconColor?: string;
  iconName: string;
  iconWidth?: string;
  middleTextDesc: ReactNode;
  middleTextTitle?: ReactNode;
  rightTextDesc: ReactNode;
};
export const BannerWithButton = ({
  ctaText,
  ctaAction,
  bannerTitle,
  bannerPadding = 'p-0',
  iconColor = 'inherit',
  iconName,
  iconWidth = '3rem',
  middleTextTitle,
  middleTextDesc,
  rightTextDesc,
  dataTestId = '',
}: Props) => {
  const { isTablet } = useResponsive();
  const isMobile = !isTablet;
  return (
    <div data-testid={dataTestId}>
      <Title className="mb-20" theme="title-brand-n2">
        {bannerTitle}
      </Title>
      <div className="rounded-12 border-1 border-lightGrey bg-white">
        <div className={`flex flex-col gap-10 md:flex-row md:justify-between ${bannerPadding}`}>
          <div className="flex w-full items-center gap-20 md:items-start">
            <Icon className={`text-${iconColor}`} hasRtl name={iconName} width={iconWidth} />
            <div className="w-full">
              <div className="flex w-full items-center justify-between text-14">
                {middleTextTitle}
                {middleTextDesc}
                <p className="w-1/3 text-right text-14 font-bold">{t('common.freeService')}</p>
              </div>
              {!isMobile && <div className="flex-1 text-14">{rightTextDesc}</div>}
            </div>
          </div>
          {isMobile && <div className="flex-1 text-14">{rightTextDesc}</div>}
        </div>

        <div className="mx-20 mb-20 mt-15 flex justify-center md:justify-end">
          <Button
            className="text-12 font-bold"
            data-selector="bannerWithButton-cta"
            data-testid="bannerWithButtonCta"
            onClick={ctaAction}
            size="medium"
          >
            {ctaText}
          </Button>
        </div>
      </div>
    </div>
  );
};
